// Lib
import { ThemeName } from 'lib/context/ThemeContext';

export const QuantityCardTheme = (themeName: ThemeName) => {
  switch (themeName) {
    case 'aw':
      return {
        questionLabel: 'font-sans text-theme-text text-s ml:text-l mb-s font-medium text-left',
        questionSublabel: 'text-theme-body text-body font-regular mb-s last:mb-0',
        quantityCardItemWrapper: 'flex flex-col h-full',
        quantityCardItemSelected:
          'before:border-primary before:border-[6px] md:before:border-[6px]',
        quantityCardItem:
          'quantity-card-item relative flex flex-row items-center inline-flex bg-light-gray p-xxs before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:border before:rounded-[5px] md:before:rounded-[10px] h-full w-full',
        quantityCardItemDesktop:
          'md:flex-col md:justify-center md:py-ml min-h-[64px] md:min-h-[255px]',
        image: 'md:mb-m mr-xxs md:mr-0 relative',
        infoContainer: 'relative flex flex-col items-start justify-center w-full md:items-center',
        title: 'text-xs font-heavy md:font-bold md:text-center mb:xxxs md:mb-xxxs',
        description: 'md:text-center text-body text-dark-gray',
        numberInput: 'relative flex flex-row items-center justify-center mt-s',
        input:
          'flex h-8 w-20 md:w-28 rounded-[100px] border text-sm-xs font-regular placeholder:text-dark-gray px-s focus:ring-0 focus:border-2 focus:border-black',
        inputButton:
          'select-none relative flex min-w-[15px] min-h-[15px] font-serif text-white bg-black font-bold text-xxs text-center justify-center items-center align-middle hover:cursor-pointer',
      };
    case 'rba':
      return {
        questionLabel: 'font-sans text-theme-text text-s ml:text-l mb-s font-medium text-left',
        questionSublabel: 'text-theme-body text-body font-regular mb-s last:mb-0',
        quantityCardItemWrapper: 'flex flex-col h-full',
        quantityCardItemSelected:
          'before:border-primary before:border-[6px] md:before:border-[6px]',
        quantityCardItem:
          'quantity-card-item relative flex flex-row items-center inline-flex bg-light-gray p-xxs before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:border before:rounded-[5px] md:before:rounded-[10px] h-full w-full',
        quantityCardItemDesktop:
          'md:flex-col md:justify-center md:py-ml min-h-[64px] md:min-h-[255px]',
        image: 'md:mb-m mr-xxs md:mr-0 relative',
        infoContainer: 'relative flex flex-col items-start justify-center w-full md:items-center',
        title: 'text-xs font-heavy md:font-bold md:text-center mb:xxxs md:mb-xxxs',
        description: 'md:text-center text-body text-dark-gray',
        numberInput: 'relative flex flex-row items-center justify-center mt-s',
        input:
          'flex h-8 w-20 md:w-28 rounded-[100px] border text-sm-xs font-regular placeholder:text-dark-gray px-s focus:ring-0 focus:border-2 focus:border-black',
        inputButton:
          'select-none relative flex min-w-[15px] min-h-[15px] font-serif text-white bg-black font-bold text-xxs text-center justify-center items-center align-middle hover:cursor-pointer',
      };
  }
};
